import { computed, defineComponent } from '@nuxtjs/composition-api';
import { getDisplayedBPM, shortenSeriesName } from '~/api/song';
export default defineComponent({
    props: {
        songs: { type: Array, default: () => [] },
        loading: { type: Boolean, default: false },
    },
    setup(props) {
        // Computed
        const displayedSongs = computed(() => props.songs.map(s => ({
            id: s.id,
            name: s.name,
            artist: s.artist,
            series: shortenSeriesName(s.series),
            bpm: getDisplayedBPM(s),
        })));
        return { displayedSongs };
    },
});
